import { Expose } from "class-transformer";

export class CreateElementDto {
  @Expose()
  name: string;
}
